import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import BackButton from '../components/BackButton';
import Loader from '../components/Loader';
import Trigger from '../components/Modals/payments/Triggers';
import apiUrl from '../utils/apiUrl';

const FoundationInfo = () => {
  const { id } = useParams();
  const [foundationInfo, setFoundationInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFoundationInfo = async () => {
      try {
        const response = await fetch(
          `${apiUrl.apiUrl}/foundations/foundation/name/${id.replace(
            /_/g,
            '%20'
          )}`
        );
        if (!response.ok) {
          throw new Error('Error fetching foundation info');
        }
        const data = await response.json();
        if (!data.foundation) {
          throw new Error('Foundation not found');
        }
        setFoundationInfo(data.foundation);
      } catch (error) {
        console.error('Error fetching foundation info:', error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchFoundationInfo();
  }, [id]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className='info-page'>
          <div className='banner'>
            <img
              src={foundationInfo.logo}
              alt=''
              className='profile-thumbnail'
            />
          </div>
          <BackButton />

          <div className='content'>
            <h2>{foundationInfo.name.toUpperCase()}</h2>

            <div className='info'>
              <p className='description'>{foundationInfo.description}</p>
              <div className='profile-social-media'>
                {foundationInfo.instagram && (
                  <span>
                    <a
                      href={'https://instagram.com/' + foundationInfo.instagram}
                      target='_blank'
                      rel='noopener noreferrer'>
                      <i className='fab fa-instagram' />
                    </a>
                  </span>
                )}
                {foundationInfo.facebook && (
                  <span>
                    <a
                      href={'https://facebook.com/' + foundationInfo.facebook}
                      target='_blank'
                      rel='noopener noreferrer'>
                      <i className='fab fa-facebook' />
                    </a>
                  </span>
                )}
                {foundationInfo.twitter && (
                  <span>
                    <a
                      href={'https://twitter.com/' + foundationInfo.twitter}
                      target='_blank'
                      rel='noopener noreferrer'>
                      <i className='fab fa-twitter' />
                    </a>
                  </span>
                )}
              </div>
            </div>
            {foundationInfo.constitutionDate && (
              <div className='constitution-date'>
                <h3>Año de fundación: </h3>
                <p>{foundationInfo.yearFounded}</p>
              </div>
            )}
            {foundationInfo.mission && (
              <>
                <h2>Misión</h2>
                <p>{foundationInfo.mission}</p>
              </>
            )}
            <hr />
            {foundationInfo.achievements && (
              <>
                <h3>Logros</h3>
                <p>{foundationInfo.achievements}</p>
              </>
            )}

            <div className='media'>
              {console.log(foundationInfo)}
              {foundationInfo.video && (
                <div className='video'>
                  <iframe
                    title='foundation video'
                    className='selectedSlideVideo'
                    src={foundationInfo.video}
                    alt='foundation video'
                    frameBorder='1'
                    allow='accelerometer; encrypted-media; gyroscope; picture-in-picture'
                    allowFullScreen
                  />
                </div>
              )}
              <Swiper
                className='swiper-container'
                slidesPerView={1}
                spaceBetween={30}
                pagination={{
                  dynamicBullets: true,
                  clickable: true,
                }}
                autoplay={{
                  delay: 3000,
                }}
                centeredSlides={true}
                loop={true}
                navigation={true}
                modules={[Autoplay, Pagination, Navigation]}>
                {foundationInfo.photos.filter(Boolean).map((image, index) => (
                  <SwiperSlide key={index}>
                    <img
                      src={image}
                      alt='foundation'
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
            <Trigger
              foundation={foundationInfo.name}
              foundationId={foundationInfo._id}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default FoundationInfo;
